let instance: AppAuth | undefined;

export class AppAuth {
	static getInstace() {
		if (!instance) {
			instance = new AppAuth();
		}
		return instance;
	}
	listeners: { (user: { sub: string } | undefined): void }[] = [];

	private user?: { sub: string };

	constructor() {
		this.user = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")!) : undefined;
	}

	getUser() {
		return this.user;
	}

	signOut() {
		this.user = undefined;
		sessionStorage.removeItem("user");
		this.listeners.forEach(l => l(undefined));
	}

	signin(user: { sub: string }) {
		this.user = user;
		sessionStorage.setItem("user", JSON.stringify(user));
		this.listeners.forEach(l => l(user));
	}

	onAuthStateChanged(callback: (user: { sub: string } | undefined) => void) {
		this.listeners.push(callback);
		return () => {
			this.listeners = this.listeners.filter(l => l != callback);
		};
	}
}
